import './styles.scss';

import WatchLaterIcon from '@mui/icons-material/WatchLater';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import SearchIcon from '@mui/icons-material/Search';
import DensityMediumOutlinedIcon from '@mui/icons-material/DensityMediumOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HttpIcon from '@mui/icons-material/Http';
import LanguageIcon from '@mui/icons-material/Language';


import { Button, Stack, Breadcrumbs, Typography, Modal, Box, Drawer, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate  } from "react-router-dom";

const Home = () => {

  const people_row_1 = [
    {
      image: 'AbigailJeric_Erne.jpg',
      name: 'Coach Jeric Erne <br /> and Abigail Erne',
      modalName: 'Coach Jeric Erne and Abigail Erne',
      position: 'Team Erners',
      description: `Dahil sa tulong ng QBS KBC na pagtapos ko sa College ang kapatid ko, nabilihan ko din ng brand new Van ang parents ko fully paid. At yung growth ko as a person unti-unti ko nakita na madami pa akong kayang abutin. Kaya I'm glad to help other people as well na makita ang purpose nila by helping them experience financial breakthroughs.
      <br />
      Ang tagal ko naghanap ng Opportunity na kaya kong kitain ang 6 digits a month, sabi ko gagalingan ko, at wala akong sasayangin na panahon. Kaya kapag nandyan na sa harap mo ang pagkakataon, grab it and do whatever it takes to be successful.
      <br />
      <span class='quote'> Grind as if you're broke, while others play as if they're rich. </span>
      `,
      hasFB: 'www.facebook.com',
      hasWeb: 'www.facebook.com'
    },
    {
      image: 'KarenPatrick_Esmundo.JPG',
      name: 'Coach Patrick Esmundo <br /> and Karen Esmundo',
      position: 'Team Majesty',
      description: `QBS & KBC has helped us become aware with what we have to constantly improve on, in order to succeed and stay successful in this business. Its all about self development at any age.
        <br />
        QBS & KBC and our mentors has shown everyone, BY EXAMPLE, how to go from Zero to Hero and all we have to do is create the discipline to transform our mindset, actionset, toolset, habitset and skillset to be someone whose value is worth 6-7 figures monthly.
        <br />
        We, will continually help others progressively discover themselves and make the necessary adjustments to become 6-7 digit income earner monthly. 
        <br />
        We have reached 7 figure income in 8 months, which would not be possible without QBS & KBC’s help.
        <br />
        Everyone deserves the best things in life and all that is needed is for us to have big goals, focus on those goals, learn what it will take to achieve those goals, then work through every challenge and hardship until we achieve our goals. Then set new ones.
        <br />
        <span class='quote'> Dream. Believe. Feel. Act. Adjust. Act. Repeat, until you become the best version of yourself. All to Glorify Our Creator, even Jesus Christ. </span>
      `,
      hasFB: 'www.facebook.com',
      hasIG: 'www.facebook.com'
    }
  ]

  const people_row_2 = [
    {
      image: 'JaniceArt_Enciso.JPG',
      name: 'Coach Art Enciso <br /> and Janice Enciso',
      modalName: 'Coach Art Enciso and Janice Enciso',
      position: 'Team Fab',
      objectPosition: 'center',
      description:  `From being a Certified Public Accountant and former Bank Audit Officer to becoming a full-time Online Entrepreneur, Janice has embraced a life of purpose and passion. Her journey began as an OFW, striving for her family's future—until QBS KBC opened doors she never imagined. “This business taught me to dream bigger and realize my true potential. I discovered new skills I never knew I had. Most importantly, it gave me the time and financial freedom to focus on what truly matters—my family and my kids.”
        <br />
        Art, a former corporate accountant and banker, also transitioned from the OFW life into the digital world. “Being new in the industry, QBS KBC equipped me mentally, emotionally, and personally. What started as a leap of faith became a journey of fulfillment and growth. The things that seemed impossible before are now made possible. This is more than just a business—it's a platform for purpose and impact.”
        <br />
        Together, Janice and Art are committed to empowering others to break boundaries, discover their inner strengths, and achieve the life they deserve through QBS KBC.
        <br />
        Every decision you make today builds the foundation of your future. Invest in actions that align with your dreams, and watch your life transform."
        "Life is beyond outside our comfort zones. Sometimes risk can be frightening, but it could turn out to be the most rewarding.
        <br />
        <span class='quote'> Don't fear failure — fear the opportunities you miss when you never take a chance. Coming together is a beginning, staying together is progress, and working together is success. </span> — Henry Ford
      `
    },
    {
      image: 'Catherine_Balisi.jpg',
      name: 'Coach Catherine Balisi',
      position: 'Team Boss Babe',
      objectPosition: 'center',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                          Cras iaculis diam varius diam ultricies lacinia.`
    }
  ]

  const people_row_3 = [
    {
      image: 'Kathleen_Acosta.JPG',
      name: 'Coach Kathleen Acosta',
      position: 'Team Angels 2.0',
      description: `QBSKBC is not just a society, they transformed lives. Skills and personal development is what we most needed to build ourselves and build our business to succeed.
        <br />
        As a Queen Boss i will continuously share the mission and purpose we have built in the society.
        <br />
        Every great achievement starts with a single step. Keep moving forward, no matter how small the progress may seem. Challenges are just stepping stones to success—embrace them, learn from them, and use them to grow. Believe in yourself, stay consistent, and never lose sight of your goals. Your hard work will pay off!
        <br />
        <span class='quote'>Success is not final, failure is not fatal: it is the courage to continue that counts.</span> – Winston Churchill
        <br />
        It’s a great reminder that both success and failure are just part of the journey, and what truly matters is persistence.
      `
    },
    {
      image: 'AngelicaAnn_Bay.jpeg',
      name: 'Coach Angelica Ann Bay',
      position: 'Team Angels 2.0',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                          Cras iaculis diam varius diam ultricies lacinia.`
    }
  ]

  const people_row_4 = [
    {
      image: 'Carlie_Bobias.jpeg',
      name: 'Coach Carlie Bobias',
      position: 'Team QBS Empire',
      objectPosition: 'center',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                          Cras iaculis diam varius diam ultricies lacinia.`
    },
    {
      image: 'SheenaAnn_Mandia.jpg',
      name: 'Coach Sheena Ann Mandia',
      position: 'Team Dropshiprenuer ',
      description: `QBSKBC helped me grow more as an individual and change my mindset positively. In return Im investing my skills and knowledge to teach more ambassadors be financially literate and manage their income properly.
        <br />
        <span class='quote'>Everything you do, put your heart and soul into it and God will bless you abundantly</span>
      `
    }
  ]

  const people_row_5 = [
    {
      image: 'MaryClaireFlorGeorge_Jumamil.jpg',
      name: 'Coach  George Jumamil <br /> and Mary Claire Flor',
      position: 'Team Extreme Believers ',
      objectPosition: 'center',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                          Cras iaculis diam varius diam ultricies lacinia.`
    },
    {
      image: 'Cynthia_Gabona.jpg',
      name: 'Coach Cynthia Gabona',
      position: 'Team BreakThrough',
      description:  `I was a former employee who lost my job during the pandemic. As a single parent, I needed stability, and this business gave me the opportunity to provide for my family. Now, I am a full-time entrepreneur, thriving and helping others achieve success.
        <br />
        QBS KBC has empowered me to overcome challenges, achieve financial independence, and grow as a leader. I am committed to guiding, inspiring, and supporting others in building a better future through this community.
        <br />
        No matter how tough life gets, never stop believing in yourself. Your hard work today will build a brighter tomorrow.
        <br />
        <span class='quote'>Success is not just about earning, it’s about learning, growing, and lifting others along the way.</span>
      `
    }
  ]

  const people_row_6 = [
    {
      image: 'MaCresencia_Pilapil.jpeg',
      name: 'Coach Ma Cresencia Pilapil',
      position: 'Team Wagi ',
      objectPosition: 'center',
      description:`Like many of you, I am a mother who only wanted one thing - to give my family a better life. I was once an OFW Agent, but when the pandemic struck, I lost my job and faced uncertainty. But as a mom, we don’t have the luxury to give up. We push forward, no matter what.
        <br />
        That’s when QBS KBC changed my life. It opened doors I never knew existed, giving me a way to earn without sacrificing time with my family. It helped me achieve one of my biggest dreams—a house and lot for my children—and most importantly, it helped me rediscover my strength, confidence, and purpose.
        <br />
        Now, my mission is to help fellow moms who are searching for a way to provide for their families without missing out on precious moments. If you feel stuck, exhausted, or hopeless, know that you are not alone. There is a way out, and I am here to guide and support you.
        <br />
        Success isn’t just about money—it’s about giving our children the future they deserve. And as moms, we will do whatever it takes!
        <br />
        <span class='quote'>Commit to the Lord whatever you do, and your plans will succeed. – Proverbs 16:3</span>
      `
    },
    {
      image: 'ValentinoAustria.jpg',
      name: 'Coach Valentino Austria',
      position: 'Team Wagi ',
      objectPosition: 'top',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                          Cras iaculis diam varius diam ultricies lacinia.`
    }
  ]

  const last_row = [
    {
      image: 'Janice_Sutaso.JPG',
      name: 'Coach Janice Sutaso',
      position: 'Team Splendid',
      description: `Queen Boss Society has played a significant role in my personal growth, helping me step out of my comfort zone.
        Financially, this community has also become an additional source of income for me.
        <br />
        I can contribute to our community by sharing knowledge, skills, and experiences that inspire and empower others. Whether through mentorship, training sessions, or motivational support, I aim to help individuals develop confidence, step out of their comfort zones, and achieve their personal and financial goals. Additionally, I can assist in fostering a positive and supportive environment where members uplift and encourage one another toward success.
        <br />
        Every great achievement begins with a small step, and every challenge is an opportunity to grow. Stay focused on your goals, embrace failures as lessons, and never stop pushing forward. Your dreams are within reach, keep going, stay determined, and success will follow!
        <br />
        <span class='quote'>Don’t be pushed around by the fears in your mind. Be led by the dreams in your heart.</span> – Roy T. Bennett
      `
    }
  ]
  
  const [isSticky, setIsSticky] = useState(false);
  const isMobile = window.innerWidth >=769 ? false : true;
  const modalWidth = window.innerWidth >=769 ? '80vw' : '90vw';

  useEffect(() => {
    const handleScroll = () => {
      console.log('-- window.innerWidth --', window.innerWidth);
      const scrollThreshold = window.innerWidth <= 768 ? 5 : 50; // 20px for mobile, 50px for desktop
      setIsSticky(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [moreDetailsModal, setMoreDetailsModal] = useState({
    visible: false,
    item: {}
  })

  const mobileMmenuItems = [
    { text: 'Home', path: '/' },
    { text: 'Awards', path: '/awards' },
    { text: 'Events', path: '/events' },
    { text: 'Gallery', path: '/gallery' }
  ];
  
  const modalBodyRef = useRef(null);
  const [showArrow, setShowArrow] = useState(true);
  useEffect(() => {
    let observerFrame;
    if(!isMobile)
      return;
  
    const waitForRef = () => {
      const el = modalBodyRef.current;
      if (el) {
        console.log('-- hasEl --');
  
        const handleScroll = () => {
          if (el.scrollTop > 10) {
            setShowArrow(false);
          } else {
            setShowArrow(true);
          }
        };
  
        el.addEventListener('scroll', handleScroll);
  
        // Cleanup
        return () => {
          el.removeEventListener('scroll', handleScroll);
        };
      } else {
        // Wait for next frame and try again
        observerFrame = requestAnimationFrame(waitForRef);
      }
    };
  
    if (moreDetailsModal?.visible) {
      observerFrame = requestAnimationFrame(waitForRef);
      setShowArrow(true);
    }
  
    return () => {
      if (observerFrame) cancelAnimationFrame(observerFrame);
    };
  }, [moreDetailsModal?.visible]);

  const modalStyle = {
    width: modalWidth,
    height: '80vh', 
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFF',
    border: '2px solid #058283',
    boxShadow: 24,
    borderRadius: '10px',
    padding: isMobile ? '0px' : '20px',
    overflow: isMobile ? 'visible' : 'hidden', 
    display: 'flex',
    flexDirection: 'column'
  };

  const PeopleDetails = ({item, ind}) => {

    const descRef = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);

    useEffect(() => {
      const el = descRef.current;
      if (el) {
        const isOverflowing = el.scrollHeight > el.clientHeight;
        setIsOverflowed(isOverflowing);
      }
    }, [item.description]);

    const handleShowModal = (item) => {
      setMoreDetailsModal({
        visible: true,
        item
      })
    }

    const handleSocmedClick = (item) => {
      console.log('-- socmed ---', item);
    }

    return <Stack className='people_container' key={ind}  onClick={() => handleShowModal(item)}>
        <Stack className='img_container'>
            <img alt='people_img' src={`/images/people/${item.image}`} style={{ objectPosition: moreDetailsModal?.item?.objectPosition ?? 'top' }} />
        </Stack>

        <Stack className='detail_container'>
            <Stack className='name'>
              <h4
                dangerouslySetInnerHTML={{
                  __html: item.name
                }}
              />
            </Stack>
            <Stack className='position'>{item.position}</Stack>
            <Stack className='description_container'>
              <Stack
                className='description'
                ref={descRef}
              >
                {item.description}
                
              </Stack>

              {isOverflowed && (
                <Typography className='read-more-btn'>
                  Read More
                </Typography>
              )}
            </Stack>

            <Stack className='people_socmed'>
              <FacebookIcon className={`icons${!item.hasFB ? ' icon_disabled' : ''}`} onClick={(e) => {
                e.stopPropagation();
                handleSocmedClick(item)
              }} />
              <InstagramIcon className={`icons${!item.hasIG ? ' icon_disabled' : ''}`} onClick={(e) => {
                e.stopPropagation();
                handleSocmedClick(item)
              }} />
              <LanguageIcon className={`icons${!item.hasWeb ? ' icon_disabled' : ''}`} onClick={(e) => {
                e.stopPropagation();
                handleSocmedClick(item)
              }} />
            </Stack>
        </Stack>
    </Stack>
  }

  const { code } = useParams();
  const navigate = useNavigate();
  // const [isValid, setIsValid] = useState(false);

  // useEffect(() => {
  //     if (code === '3349b15d-dd02-4494-adde-9ca1667b04f7') {
  //         setIsValid(true);
  //     } else {
  //         navigate("/", { replace: true }); // Redirect if invalid
  //     }
  // }, [code, navigate]);


  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = (open) => () => {
    setOpenDrawer(open);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {mobileMmenuItems.map((item) => (
          <ListItem key={item.text} disablePadding onClick={() => navigate(item.path)}>
            <ListItemButton>
              {/* <ListItemIcon>
                {index % 2 === 0 ? <SearchIcon /> : <SearchIcon />}
              </ListItemIcon> */}
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['Keep Me Posted'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              {/* <ListItemIcon>
                {index % 2 === 0 ? <Pur /> : <SearchIcon />}
              </ListItemIcon> */}
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  
  // if (!isValid) return null; // Prevent rendering if invalid

  return (
    <div className="Home_page">
      
      <Drawer 
        open={openDrawer} 
        onClose={toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>

      <Stack className="navheader">
        <Stack className="navheader_container">
          <Stack className="navheader_wrapper">
            <Stack className='left_side'>
              <Stack className='left_side_content'>
                <WatchLaterIcon sx={{ fontSize: '18px' }} />
                <span>Open Hours: Mon - Sat - 09:00 - 18:00</span>
              </Stack>
            </Stack>
            <Stack className='right_side'>
                {/* <Stack className='right_side_content'>
                  <PhoneIcon sx={{ fontSize: '18px' }} />
                  <span>+63 995-553-9630</span>
                </Stack>
                <Stack className='right_side_content'>
                  <EmailIcon sx={{ fontSize: '18px' }} />
                  <span>hello@example.com</span>
                </Stack> */}
                <Stack className='socmed_icons'>
                  <FacebookIcon className='icons' />
                  <TwitterIcon className='icons' />
                  <InstagramIcon className='icons' />
                </Stack>
            </Stack>
          </Stack>
        </Stack>
        
        <Stack className={`header_menu_container ${isSticky ? 'sticky' : ''}`}>
          <Stack className='header_menu'>
            <Stack className='left_side'>
                <span className='featured'>QBS</span>
                <span>KBC</span>
            </Stack>
            <Stack className='right_side'>
                <Stack className='right_side_menu selected'>
                  <span>Home</span>
                </Stack>
                <Stack className='right_side_menu' onClick={() => navigate('/awards')}>
                  <span>Awards</span>
                </Stack>
                <Stack className='right_side_menu' onClick={() => navigate('/events')}>
                  <span>Events</span>
                </Stack>
                <Stack className='right_side_menu' onClick={() => navigate('/gallery')}>
                  <span>Gallery</span>
                </Stack>
                {/* <Stack className='right_side_menu'>
                  <SearchIcon />
                </Stack> */}
                <Stack>
                  <Button variant="contained" className='header_menu_button'>Keep Me Posted</Button>
                </Stack>
            </Stack>
            <Stack className='nav_toggle'>
                <Stack className='right_side_menu'>
                  <SearchIcon />
                </Stack>
                <Stack className='right_side_menu' onClick={toggleDrawer(true)}>
                  <DensityMediumOutlinedIcon />
                </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      <Stack className='header_bg_wrapper'>
        <Stack className='header_image_container'>
          <Stack className='header_section'>
            <img alt='header' src="/images/header_bg.webp" className='header_image' />
          
            <Stack className='header_main_text'>
                <Breadcrumbs aria-label="breadcrumb" className='header_breadcrumbs'>
                  <span underline="hover" color="inherit" href="/">
                    Home
                  </span>
                  <span
                    underline="hover"
                    color="inherit"
                    style={{ color: '#00a6a6' }}
                  >
                    Our People
                  </span>
                </Breadcrumbs>
                <h1>Our People</h1>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      

      <Stack className='main_content_container'>
          <Stack className="pre-title">
              we like what we do
          </Stack>
          <Stack>
            <h2>
              <span className='featured'>Meet </span>
              <span> our Coaches</span>
            </h2>
          </Stack>

          <Stack className='people_wrapper'>
            <Stack className='people_row'>
              {
                people_row_1.map((item, ind) => (
                  <PeopleDetails item={item} ind={`row1${ind}`} key={ind} />
                ))
              }
            </Stack>

            <Stack className='people_row'>
              {
                  people_row_2.map((item, ind) => (
                    <PeopleDetails item={item} ind={`row2${ind}`} key={ind} />
                  ))
                }
            </Stack>

            <Stack className='people_row'>
              {
                  people_row_3.map((item, ind) => (
                    <PeopleDetails item={item} ind={`row3${ind}`} key={ind} />
                  ))
                }
            </Stack>

            <Stack className='people_row'>
              {
                  people_row_4.map((item, ind) => (
                    <PeopleDetails item={item} ind={`row4${ind}`} key={ind} />
                  ))
                }
            </Stack>

            <Stack className='people_row'>
              {
                  people_row_5.map((item, ind) => (
                    <PeopleDetails item={item} ind={`row5${ind}`} key={ind} />
                  ))
                }
            </Stack>

            <Stack className='people_row'>
              {
                  people_row_6.map((item, ind) => (
                    <PeopleDetails item={item} ind={`row6${ind}`} key={ind} />
                  ))
                }
            </Stack>

            <Stack className='people_row'>
              {
                  last_row.map((item, ind) => (
                    <PeopleDetails item={item} ind={`last_row${ind}`} key={ind} />
                  ))
                }
            </Stack>

          </Stack>
      </Stack>

      <Stack className='footer_container'>
        <Stack className='footer_wrapper'>

        </Stack>

        <Stack className='copyright_container'>
          <Stack className='copyright_wrapper'>

          </Stack>
        </Stack>
      </Stack>

      <Modal
          open={moreDetailsModal?.visible}
          onClose={() => setMoreDetailsModal({
            visible: false, item: {}
          })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Box style={modalStyle} sx={{
                '&:focus': {
                  outline: 'none',
                },
              }}>
              <Stack className='modalBody' ref={modalBodyRef}>
                <Stack className='img_container'>
                  <img alt="people" src={`/images/people/${moreDetailsModal?.item.image}`} style={{ objectPosition: moreDetailsModal?.item?.objectPosition ?? 'top' }} />
                </Stack>

                {showArrow && (
                <Stack className='arrowMoreDetails'>
                  <KeyboardArrowDownIcon
                    sx={{
                      fontSize: 40,
                      animation: 'bounce 1s infinite',
                      color: '#2fbcbd;',
                      '@keyframes bounce': {
                        '0%, 100%': {
                          transform: 'translateY(0)',
                        },
                        '50%': {
                          transform: 'translateY(5px)',
                        },
                      },
                    }}
                  />
                </Stack>
                )}

                <Stack className='detail_container'>
                    <Stack className='name'>
                      <h4
                        dangerouslySetInnerHTML={{
                          __html: moreDetailsModal?.item.modalName ? (isMobile ? moreDetailsModal?.item.name : moreDetailsModal?.item.modalName) : moreDetailsModal?.item.name
                        }}
                      />
                    </Stack>
                    <Stack className='position'>{moreDetailsModal?.item.position}</Stack>
                    <Stack className='description'
                      dangerouslySetInnerHTML={{
                        __html: moreDetailsModal?.item.description
                      }}
                    >
                    </Stack>
                </Stack>
              </Stack>

              <Stack className='modalCloseBtnContainer'>
                <Button variant="contained"size="small" className='modalCloseBtn'
                  onClick={() => setMoreDetailsModal({
                    visible: false, item: {}
                  })}
                  sx={{
                    backgroundColor: '#058283',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#046b6b', // darker shade on hover
                    },
                  }}
                  startIcon={<CloseIcon />}
                >Close</Button>
              </Stack>
          </Box>
      </Modal>

      {/* <Stack style={{ height: '1000px', border: '1px solid #F30'}}>

      </Stack> */}
    </div>
  );
}

export default Home;
